<div class="tw-grid tw-gap-x-2 tw-gap-y-1 tw-grid-cols-[repeat(auto-fill,minmax(3.5rem,1fr))] ">
  <button mat-icon-button matTooltip="Clear All" (click)="onToggle('')" [disabled]="disabled()">
    <mat-icon>clear_all</mat-icon>
  </button>
  @for(state of stateList; track $index) {
  <mat-checkbox [matTooltip]="state.name" [disabled]="disabled()" [checked]="isStateSelected(state.code)"
    (change)="onToggle(state.code)">
    <span [ngClass]="{'tw-font-semibold': isStateSelected(state.code)}">{{state.code}}</span>
  </mat-checkbox>
  }
</div>